import { formatDistance } from '../utils/dealer-map-utils';
import { useTranslation } from 'next-i18next';
import { DSIcon } from '@stihl-design-system/components';

export const DealerDistanceLabel = ({ distance }: { distance?: number }) => {
  const { t, i18n } = useTranslation(['shared']);
  const country = i18n?.language?.split('-')?.[1];
  if (!distance) {
    return null;
  }

  return (
    <div className="flex shrink-0 items-center gap-2 stihl-text-body-default-reg">
      <DSIcon name="distance" />
      <span className="flex space-x-2" data-testid="dealer-distance">
        <span className="mr-2 hidden lg:inline-block">{t('shared_dealers_map_list_labelDistance')}</span>
        {formatDistance(distance, country, t('shared_dealers_map_list_labelDistance_unit'))}
      </span>
    </div>
  );
};
